"use client";

import { useRouter } from "next/navigation";
import { Toggle } from "@/components/base/toggle/toggle";
import { MEMBERSHIP_PLANS } from "@/consts/membership";
import { signOut } from "@/lib/auth-client";
import { useAuth } from "@/providers/auth";
import { useDebugSettings } from "@/providers/debug-settings";
import type { MembershipPlanId } from "@/types/membership";
import { cx } from "@/utils/cx";
export function DebugMenuPanel() {
  const router = useRouter();
  const {
    isLoggedIn,
    user,
    setMembershipPlan
  } = useAuth();
  const {
    assumptionControlsEnabled,
    setAssumptionControlsEnabled,
    volTvlEnabled,
    setVolTvlEnabled
  } = useDebugSettings();
  const handleLogout = async (loggedIn: boolean) => {
    if (!loggedIn && isLoggedIn) {
      await signOut();
      router.refresh();
    } else if (loggedIn && !isLoggedIn) {
      try {
        const res = await fetch("/api/debug/quick-login", {
          method: "POST",
          credentials: "include"
        });
        if (!res.ok) {
          const body = (await res.json().catch(() => ({}))) as {
            error?: string;
          };
          console.warn("[DebugMenu]", body.error ?? `Quick sign-in failed (${res.status})`);
          return;
        }
        router.refresh();
      } catch (err) {
        console.error("Debug login error:", err);
      }
    }
  };
  const handlePlanSelect = (planId: MembershipPlanId) => {
    setMembershipPlan(planId);
  };
  const isLoggedInAndUser = isLoggedIn && user;
  const canSpoofMembership = user?.role !== "support";
  return <div className="space-y-3 p-3" onClick={e => e.stopPropagation()}>
			<div className="flex items-center justify-between gap-3">
				<label className="text-sm font-medium text-secondary">Fee Explanations</label>
				<Toggle aria-label="Fee Explanations" isSelected={assumptionControlsEnabled} onChange={setAssumptionControlsEnabled} />
			</div>
			<div className="flex items-center justify-between gap-3">
				<label className="text-sm font-medium text-secondary">Vol/TVL</label>
				<Toggle aria-label="Vol/TVL" isSelected={volTvlEnabled} onChange={setVolTvlEnabled} />
			</div>
			<div className="flex items-center justify-between gap-3">
				<label className="text-sm font-medium text-secondary">Logged In</label>
				<Toggle aria-label="Logged in" isSelected={isLoggedIn} onChange={handleLogout} />
			</div>
			{user && <div className="rounded-md bg-secondary/50 px-2 py-2 text-sm">
					<div className="font-medium text-secondary">User: {user.email}</div>
					<div className="text-tertiary">Plan: {user.membership.planId}</div>
				</div>}

			{canSpoofMembership ? <div className={cx("space-y-2 border-t border-border-secondary pt-2", !isLoggedInAndUser && "pointer-events-none opacity-50")}>
					<label className="text-sm font-medium text-secondary">Membership Plan</label>
					<div className="space-y-1.5">
						{Object.values(MEMBERSHIP_PLANS).map(plan => <button key={plan.id} type="button" onClick={() => handlePlanSelect(plan.id)} className={cx("w-full rounded-md px-2.5 py-1.5 text-left text-sm font-medium transition-colors", isLoggedInAndUser && user?.membership.planId === plan.id ? "bg-brand-solid text-white" : "text-secondary hover:bg-primary_hover")}>
								{plan.name} (${plan.price.monthly}/mo)
							</button>)}
					</div>
				</div> : null}
		</div>;
}